import { getMonotoringAndEvaluationModule } from '../../config/apiSinToken'

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener el listado de cuestionario
 * Fecha: 24-10-2023
 */
export const getMonitoringAndEvaluationQuestionnaireAnswers = async (
  params,
) => {
  const data = await getMonotoringAndEvaluationModule(
    `api/v1/MonitoringAndEvaluationQuestionnaireAnswers/Form/Get?IdIfi=${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener la informaicon del cuestionario
 * Fecha: 24-10-2023
 */
export const getMonitoringAndEvaluationQuestionnaireAnswersById = async (
  params,
) => {
  const data = await getMonotoringAndEvaluationModule(
    `api/v1/MonitoringAndEvaluationQuestionnaireAnswers/Get?IdQuestionnaireAnswer=${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener la informaicon del cuestionario
 * Fecha: 31-10-2023
 */
export const getAdaptabilityQuestionsME = async (params) => {
  const data = await getMonotoringAndEvaluationModule(
    `api/v1/AdaptabilityQuestionsME/AdaptabilityQuestions?id=${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener la informaicon del cuestionario
 * Fecha: 17-11-2023
 */
export const getAdaptabilityIndicators = async (params) => {
  const data = await getMonotoringAndEvaluationModule(
    `api/v1/AdaptabilityQuestionsME/adaptabilityIndicators`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener las mipymes para informe
 * Fecha: 27-11-2023
 */
export const getMIPYMEForInform = async (B2C) => {
  const data = await getMonotoringAndEvaluationModule(
    `api/v1/MiPymes/MiPymes/MiPymeForFormReport/${B2C}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener las mipymes para informe
 * Fecha: 27-11-2023
 */
export const getProjectsMIPYMEForInform = async (mipyme) => {
  const data = await getMonotoringAndEvaluationModule(
    `api/v1/MonitoringAndEvaluationQuestionnaireAnswers/informationReport?MiPyme=${mipyme}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener la informacion de informe
 * Fecha: 18-12-2023
 */
export const getFormReportAnswer = async (params) => {
  const data = await getMonotoringAndEvaluationModule(
    `api/v1/ReportAnswers/Get?IdQuestionnaireAnswer=${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Validar informe de final de termino
 * Fecha: 12-02-2024
 */
export const getValidationsFinalTerm = async (params) => {
  const data = await getMonotoringAndEvaluationModule(
    `api/v1/ReportAnswers/getValidations?IdQuestionnaireAnswer=${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Historico
 * Fecha: 13-02-2024
 */
export const getHistoryForm = async (params) => {
  const data = await getMonotoringAndEvaluationModule(
    `api/v1/Forms/FormHistory/${params}`,
  )
  return data
}
